// import DownOutlined from '@ant-design/icons-vue/DownOutlined';
import LoadingOutlined from '@ant-design/icons-vue/LoadingOutlined';
import CheckOutlined from '@ant-design/icons-vue/CheckOutlined';
// import CloseOutlined from '@ant-design/icons-vue/CloseOutlined';
// import CloseCircleFilled from '@ant-design/icons-vue/CloseCircleFilled';
import Icon from '../../icon';
export default function getIcons(props, slots = {}) {
    const { loading, multiple, prefixCls } = props;
    const suffixIcon = props.suffixIcon || (slots.suffixIcon && slots.suffixIcon());
    const clearIcon = props.clearIcon || (slots.clearIcon && slots.clearIcon());
    const menuItemSelectedIcon = props.menuItemSelectedIcon || (slots.menuItemSelectedIcon && slots.menuItemSelectedIcon());
    const removeIcon = props.removeIcon || (slots.removeIcon && slots.removeIcon());
    // Clear Icon
    let mergedClearIcon = clearIcon;
    if (!clearIcon) {
        mergedClearIcon = <Icon iconClass="wd-icon-tips_close_circle_fill"/>;
    }
    // Arrow item icon
    let mergedSuffixIcon = null;
    if (suffixIcon !== undefined) {
        mergedSuffixIcon = suffixIcon;
    }
    else if (loading) {
        mergedSuffixIcon = <LoadingOutlined spin/>;
    }
    else {
        const iconCls = `${prefixCls}-suffix`;
        mergedSuffixIcon = ({ open, showSearch }) => {
            if (props.stockSearch && props.searchIconPlacement === 'left') {
                return null;
            }
            // 股票搜索组件固定显示搜索图标
            if (props.stockSearch && props.searchIconPlacement === 'right') {
                return <Icon class={`${prefixCls}-suffix-search`} iconClass="wd-icon-interactive_search"/>;
            }
            if (open && showSearch) {
                return <Icon class={`${prefixCls}-suffix-search`} iconClass="wd-icon-interactive_search"/>;
            }
            return <Icon icon-class={`wd-icon-direction_${open ? 'up' : 'down'}`} class={iconCls}/>;
        };
    }
    let prefixIcon = null;
    if (props.stockSearch && props.searchIconPlacement === 'left') {
        prefixIcon = (<Icon class={`${prefixCls}-suffix-search`} iconClass="wd-icon-interactive_search"/>);
    }
    // Checked item icon
    let mergedItemIcon = null;
    if (menuItemSelectedIcon !== undefined) {
        mergedItemIcon = menuItemSelectedIcon;
    }
    else if (multiple) {
        mergedItemIcon = <CheckOutlined />;
    }
    else {
        mergedItemIcon = null;
    }
    let mergedRemoveIcon = null;
    if (removeIcon !== undefined) {
        mergedRemoveIcon = removeIcon;
    }
    else {
        mergedRemoveIcon = <Icon iconClass="wd-icon-tips_close_circle_fill"/>;
    }
    return {
        clearIcon: mergedClearIcon,
        suffixIcon: mergedSuffixIcon,
        prefixIcon,
        itemIcon: mergedItemIcon,
        removeIcon: mergedRemoveIcon,
    };
}
